import { fetchBasicUrlPostJson, getDateStr } from '@/script/common';

var userInfoService = (function () {
    function getUserInfo(date) {
        return fetchBasicUrlPostJson(`/Mio/UserInfo`, {
            data: {
                date: date || getDateStr(new Date())
            }
        })
    }
    return {
        getUserInfo
    };
})();

export default userInfoService;
